export default {
    EXPERIENCE_NAME_MAX_LENGTH: 200,
    EXPERIENCE_VERSION_NAME_MAX_LENGTH: 50,
    EXPERIENCE_BASE_URL_MAX_LENGTH: 600,
    EXPERIENCE_TEMPLATE_NAME_MAX_LENGTH: 50,
    VIP_PROFILES: {
        // maxGoalLen: 1000,
        maxVersionsLen: 50,
        filterMaxDay: 180,
        // goal: ['4ca02132', '2c531cb1', '43czk01e', '57qglb9j', '57117aa6'],
        versions: ['43czk01e', '57qglb9j', '57117aa6'],
        filterDay: ['566d12f9']
    }
};
